const userInfo = JSON.parse(sessionStorage.getItem("ngb:user"));
const userToken = sessionStorage.getItem("ngb:bearer_token") || null;
import {
  changePassword,
  getUserDetails,
  signin,
  refreshToken
} from "@/http/auth";
export default {
  namespaced: true,
  state: {
    user: userInfo ? userInfo : {},
    token: userToken ? userToken : "",
    isLogin: userToken ? true : false,
    loading: false,
    userDetails: {},
    isCustomizerActive: false,
  },
  actions: {
    setUser({ commit }, data) {
      commit("SET_USER", data);
    },
    setToken({ commit }, data) {
      commit("SET_TOKEN", data);
    },
    toggleCustomizer({ commit }, data) {
      commit("SET_DRAWER", data);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    setUserDetail({ commit }, data) {
      commit("SET_USER_DETAIL", data);
    },
    async changePasswordAction(_, data) {
      try {
        return await changePassword(data.password, data.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async signinAction(_, data) {
      try {
        return await signin(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUserDetailsAction() {
      try {
        return await getUserDetails();
      } catch (error) {
        throw (
          error.message.defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async refreshTokenAction(_, data) {
      try {
        return await refreshToken(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_USER(state, payload) {
      Object.assign(state, { isLogin: true, user: payload });
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_DRAWER(state, payload) {
      state.isCustomizerActive = payload;
    },
    LOGOUT(state) {
      Object.assign(state, { isLogin: false, user: {} });
    },
    SET_USER_DETAIL(state, payload) {
      
      Object.assign(state, { userDetails: payload });

      Object.assign(state,{isLogin: true,user:payload})
      state.user=payload
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getToken(state) {
      return state.user.base64EncodedAuthenticationKey;
    },
    getStatus(state) {
      return state.status;
    },
    isLogin(state) {
      return state.isLogin;
    },
    isloading(state) {
      return state.loading;
    },
    userDetail(state) {
      return state.userDetails;
    },
    userType(state) {
      if (Object.keys(state.user).length) {
        return state.user.roles[0].name;
      } else return "";
    },
  },
};
